// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Pagination_wrapper__qnhCO","noWrapper":"Pagination_noWrapper__2mGpj","form":"Pagination_form__Zbl8A","pagination":"Pagination_pagination__-UcjO"};